"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Logo_1 = __importDefault(require("atomicComponents/atoms/Logo"));
var Link_1 = __importDefault(require("atomicComponents/atoms/Text/Link"));
var RatingIcon_1 = __importDefault(require("components/Icons/RatingIcon"));
var logging_1 = require("../../utils/logging");
var DealType_1 = __importDefault(require("./DealType"));
var utils_1 = require("./utils");
var PREFIX = 'Tool';
var classes = {
    dealWrapper: "".concat(PREFIX, "-dealWrapper"),
    headingText: "".concat(PREFIX, "-headingText"),
    serviceHeading: "".concat(PREFIX, "-serviceHeading"),
    serviceBox: "".concat(PREFIX, "-serviceBox"),
    serviceRating: "".concat(PREFIX, "-serviceRating"),
    serviceLightGrey: "".concat(PREFIX, "-serviceLightGrey"),
    serviceCategory: "".concat(PREFIX, "-serviceCategory"),
    serviceReplacement: "".concat(PREFIX, "-serviceReplacement"),
    serviceRepAvatar: "".concat(PREFIX, "-serviceRepAvatar"),
    serviceDescription: "".concat(PREFIX, "-serviceDescription"),
};
var Root = (0, styles_1.styled)(Link_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            height: '100%',
            display: 'block',
            padding: theme.spacing(3, 2),
            borderRadius: theme.shape.borderRadius,
            minWidth: 256,
            width: '100%',
            ':hover': {
                boxShadow: '0px 3px 8px rgba(0,0,0,0.12)',
            },
            ':focus-visible': theme.focusVisibleStyles
        },
        _b[".".concat(classes.headingText)] = {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
        },
        _b[".".concat(classes.serviceHeading)] = {
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: '16px',
            letterSpacing: '0.023em',
        },
        _b[".".concat(classes.serviceBox)] = {
            flexDirection: 'column',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
        },
        _b[".".concat(classes.serviceRating)] = {
            fontSize: theme.typography.fontSize,
            letterSpacing: '0.023em',
            color: theme.palette.text.secondary,
            paddingRight: '3px',
        },
        _b[".".concat(classes.serviceLightGrey)] = {
            color: theme.palette.grey[600],
            fontWeight: theme.typography.fontWeightLight,
            fontSize: theme.typography.fontSize,
        },
        _b[".".concat(classes.serviceCategory)] = {
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: theme.typography.fontSize,
            letterSpacing: '0.023em',
            color: theme.palette.secondary.main,
            padding: theme.spacing(1, 0),
        },
        _b[".".concat(classes.serviceReplacement)] = {
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: '14px',
            letterSpacing: '0.023em',
            paddingTop: '3px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
        },
        _b[".".concat(classes.serviceRepAvatar)] = {
            paddingBottom: '3px',
            marginRight: theme.spacing(0.75),
            // Todo: remove display none once replacements have id
            display: 'none',
        },
        _b[".".concat(classes.serviceDescription)] = {
            marginTop: theme.spacing(1),
            fontSize: '14px',
            letterSpacing: '0.023em',
            color: theme.palette.grey[600],
            overflow: 'hidden',
            maxHeight: '70px',
            display: '-webkit-box',
            WebkitLineClamp: 1,
            WebkitBoxOrient: 'vertical',
            wordBreak: 'break-all',
        },
        _b);
});
var Tool = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var service = _a.service;
    var repService = ((_b = service.comparisons) === null || _b === void 0 ? void 0 : _b.filter(function (comp) { return comp.id; })[0]) || ((_c = service.comparisons) === null || _c === void 0 ? void 0 : _c[0]);
    if (service.hasDeals && !((_d = service.deals) === null || _d === void 0 ? void 0 : _d.d1)) {
        (0, logging_1.logError)("".concat(service.id, " marked with hasDeals, but has no deal d1"));
    }
    return ((0, jsx_runtime_1.jsxs)(Root, __assign({ to: "/tools/".concat(service.metaCategoryId, "/").concat(service.slug) }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex" }, { children: [(0, jsx_runtime_1.jsx)(Logo_1.default, { brand: service, size: "xl" }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ ml: 1, className: classes.serviceBox }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: (0, classnames_1.default)(classes.serviceHeading, classes.headingText) }, { children: service.name || 'Service' })), service.rating && service.rating !== 'n/a' && ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(RatingIcon_1.default, { rating: (0, utils_1.getServiceRating)(service.rating) }), (0, jsx_runtime_1.jsx)("span", __assign({ className: classes.serviceRating }, { children: (0, utils_1.getServiceRating)(service.rating).toFixed(1) }))] })))] }))] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ height: "100%" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ className: (0, classnames_1.default)(classes.serviceCategory, classes.headingText) }, { children: ((_e = service.categories) === null || _e === void 0 ? void 0 : _e[0]) || 'Category Name' })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ className: classes.serviceLightGrey }, { children: "Replaces" })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ className: classes.serviceReplacement }, { children: [repService && (0, jsx_runtime_1.jsx)(Logo_1.default, { brand: repService, className: classes.serviceRepAvatar, size: "sm" }), (0, jsx_runtime_1.jsx)("span", __assign({ className: classes.headingText }, { children: (repService === null || repService === void 0 ? void 0 : repService.name) || '...' }))] })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ className: (0, classnames_1.default)(classes.serviceDescription) }, { children: service.description || '(Tool description missing)' })), service.hasDeals && ((_f = service.deals) === null || _f === void 0 ? void 0 : _f.d1) && (0, jsx_runtime_1.jsx)(DealType_1.default, { deal: (_g = service.deals) === null || _g === void 0 ? void 0 : _g.d1 })] }))] })));
};
exports.default = react_1.default.memo(Tool);
